import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addPermission, editPermission, queryTreeList } from '@/api/api';
import Icons from "./icon/Icons";
import pick from 'lodash.pick';
export default {
  name: "PermissionModal",
  components: {
    Icons: Icons
  },
  data: function data() {
    return {
      configVisible: false,
      //配置弹框按钮状态
      configFormData: [],
      //配置弹框对应数据
      configFormColumn: [{
        title: '键',
        dataIndex: 'dataKey',
        key: 'dataKey',
        scopedSlots: {
          customRender: 'key'
        }
      }, {
        title: '值',
        dataIndex: 'dataValue',
        key: 'dataValue',
        scopedSlots: {
          customRender: 'value'
        }
      }, {
        title: '操作',
        key: 'operation',
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      //配置弹框对应的列的数据
      drawerWidth: 700,
      treeData: [],
      treeValue: '0-0-4',
      title: "操作",
      visible: false,
      disableSubmit: false,
      model: {},
      localMenuType: 0,
      alwaysShow: false,
      //表单元素-聚合路由
      menuHidden: false,
      //表单元素-隐藏路由
      routeSwitch: true,
      //是否路由菜单
      isKeepalive: true,
      //是否缓存路由
      show: true,
      //根据菜单类型，动态显示隐藏表单元素
      menuLabel: '菜单名称',
      isRequrie: true,
      // 是否需要验证
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      iconChooseVisible: false,
      validateStatus: ""
    };
  },
  computed: {
    validatorRules: function validatorRules() {
      return {
        name: {
          rules: [{
            required: true,
            message: '请输入菜单标题!'
          }]
        },
        component: {
          rules: [{
            required: this.show,
            message: '请输入前端组件!'
          }]
        },
        url: {
          rules: [{
            required: this.show,
            message: '请输入菜单路径!'
          }]
        },
        permsType: {
          rules: [{
            required: true,
            message: '请输入授权策略!'
          }]
        },
        sortNo: {
          rules: [{
            initialValue: 1.0,
            validator: this.validateNumber
          }]
        }
      };
    }
  },
  created: function created() {
    this.initDictConfig();
  },
  methods: {
    onToModel: function onToModel() {
      this.configVisible = true;
    },
    handleCancelConfig: function handleCancelConfig() {
      this.configVisible = false;
    },
    handleConfirmConfig: function handleConfirmConfig() {
      this.configVisible = false;
    },
    onToAddConfig: function onToAddConfig() {
      this.configFormData.push({
        dataKey: '',
        dataValue: ''
      });
    },
    // 复制功能
    handleCopyConfig: function handleCopyConfig() {
      var textareaC = document.createElement('textarea');
      textareaC.setAttribute('readonly', 'readonly'); //设置只读属性防止手机上弹出软键盘

      textareaC.value = JSON.stringify(this.configFormData);
      document.body.appendChild(textareaC); //将textarea添加为body子元素

      textareaC.select();
      var res = document.execCommand('copy');
      document.body.removeChild(textareaC); //移除DOM元素

      this.$message.success("复制成功！");
    },
    // 粘贴功能
    handlePasteConfig: function handlePasteConfig() {
      var _this = this;

      navigator.clipboard.readText().then(function (clipText) {
        try {
          var obj = eval('(' + clipText + ')');

          if (obj.length > 0) {
            var selectedIndex = 0;
            obj.forEach(function (item) {
              if (item.hasOwnProperty('dataKey') && item.hasOwnProperty('dataValue')) {
                selectedIndex++;
              }
            });

            if (selectedIndex == obj.length) {
              _this.configFormData = obj;

              _this.$message.success("粘贴成功！");
            } else {
              throw new Error("");
            }
          } else if (obj.length == 0) {
            throw new Error("");
          }
        } catch (e) {
          _this.$message.error("格式不正确！");
        }
      });
    },
    loadTree: function loadTree() {
      var that = this;
      queryTreeList().then(function (res) {
        if (res.success) {
          console.log('----queryTreeList---');
          console.log(res);
          that.treeData = [];
          var treeList = res.result.treeList;

          for (var a = 0; a < treeList.length; a++) {
            var temp = treeList[a];
            temp.isLeaf = temp.leaf;
            that.treeData.push(temp);
          }
        }
      });
    },
    add: function add() {
      // 默认值
      this.edit({
        status: '1',
        permsType: '1',
        route: true
      });
    },
    edit: function edit(record) {
      var _this2 = this;

      this.configFormData = [];
      this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度

      this.form.resetFields();
      this.model = Object.assign({}, record);

      if (this.model.parentId) {
        this.model.parentId = this.model.parentId.toString();
      }

      if (this.model.perms) {
        var configFromData = this.model.perms.split(';');

        if (configFromData.length > 1) {
          this.model.perms = configFromData[0];

          for (var i = 1; i < configFromData.length; i++) {
            var item = configFromData[i].split('=');
            this.configFormData.push({
              dataKey: item[0],
              dataValue: item[1]
            });
          }
        }
      } //--------------------------------------------------------------------------------------------------
      //根据菜单类型，动态展示页面字段


      console.log(this.model);
      this.alwaysShow = !record.alwaysShow ? false : true;
      this.menuHidden = !record.hidden ? false : true;

      if (record.route != null) {
        this.routeSwitch = record.route ? true : false;
      }

      if (record.keepAlive != null) {
        this.isKeepalive = record.keepAlive ? true : false;
      } else {
        this.isKeepalive = false; // 升级兼容 如果没有（后台没有传过来、或者是新建）默认为false
      } //console.log('record.menuType', record.menuType);


      this.show = record.menuType == 2 ? false : true;
      this.menuLabel = record.menuType == 2 ? '按钮/权限' : '菜单名称';

      if (this.model.parentId) {
        this.localMenuType = 1;
      } else {
        this.localMenuType = 0;
      } //----------------------------------------------------------------------------------------------


      this.visible = true;
      this.loadTree();
      var fieldsVal = pick(this.model, 'name', 'perms', 'permsType', 'component', 'url', 'appUrl', 'colour', 'sortNo', 'menuType', 'status');
      this.$nextTick(function () {
        _this2.form.setFieldsValue(fieldsVal);
      });
    },
    close: function close() {
      this.$emit('close');
      this.disableSubmit = false;
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          _this3.model.alwaysShow = _this3.alwaysShow;
          _this3.model.hidden = _this3.menuHidden;
          _this3.model.route = _this3.routeSwitch;
          _this3.model.keepAlive = _this3.isKeepalive;
          var formData = Object.assign(_this3.model, values);

          if ((formData.menuType == 1 || formData.menuType == 2) && !formData.parentId) {
            that.validateStatus = 'error';
            that.$message.error("请检查你填的类型以及信息是否正确！");
            return;
          } else {
            that.validateStatus = 'success';
          }

          if (that.configFormData.length > 0) {
            that.configFormData.forEach(function (item) {
              formData.perms += ";".concat(item.dataKey, "=").concat(item.dataValue);
            });
          }

          that.confirmLoading = true;
          console.log(formData);
          var obj;

          if (!_this3.model.id) {
            obj = addPermission(formData);
          } else {
            obj = editPermission(formData);
          }

          obj.then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    validateNumber: function validateNumber(rule, value, callback) {
      if (!value || new RegExp(/^[0-9]*[1-9][0-9]*$/).test(value)) {
        callback();
      } else {
        callback("请输入正整数!");
      }
    },
    onChangeMenuType: function onChangeMenuType(e) {
      var _this4 = this;

      //console.log('localMenuType checked', e.target.value)
      this.localMenuType = e.target.value;

      if (e.target.value == 2) {
        this.show = false;
        this.menuLabel = '按钮/权限';
      } else {
        this.show = true;
        this.menuLabel = '菜单名称';
      }

      this.$nextTick(function () {
        _this4.form.validateFields(['url', 'component'], {
          force: true
        });
      });
    },
    selectIcons: function selectIcons() {
      this.iconChooseVisible = true;
    },
    handleIconCancel: function handleIconCancel() {
      this.iconChooseVisible = false;
    },
    handleIconChoose: function handleIconChoose(value) {
      console.log(value);
      this.model.icon = value;
      this.form.icon = value;
      this.iconChooseVisible = false;
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize: function resetScreenSize() {
      var screenWidth = document.body.clientWidth;

      if (screenWidth < 500) {
        this.drawerWidth = screenWidth;
      } else {
        this.drawerWidth = 700;
      }
    },
    initDictConfig: function initDictConfig() {},
    handleParentIdChange: function handleParentIdChange(value) {
      console.log(value);

      if (!value) {
        this.validateStatus = "error";
      } else {
        this.validateStatus = "success";
      }
    }
  }
};